<template>
  <b-modal
    id="purchase-seats-successful"
    ref="purchase-seats-successful"
    size="purchase-successful"
    centered
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="modal-head">
      <i class="atto atto-team-light" />
      <h4>{{ label.get('subscription_seats_purchased_successfully') }}</h4>
    </div>
    <div class="content-wrapper">
      <p>
        {{ label.get('subscription_purchased_seats_successfully_description', {seats: seats}) }}
      </p>
    </div>
    <div class="modal-footer">
      <button
        v-if="!showInviteButton"
        type="submit"
        class="atto-btn submit"
        @click="close"
      >
        {{ label.get('continue') }}
      </button>

      <button
        v-if="showInviteButton"
        type="submit"
        class="atto-btn cancel"
        @click="close"
      >
        {{ label.get('later') }}
      </button>
      <button
        v-if="showInviteButton"
        type="submit"
        class="atto-btn submit"
        @click="inviteMembers"
      >
        {{ label.get('invite_members') }}
      </button>
    </div>
  </b-modal>
</template>

<script>
    export default {
        name: "PurchaseSeatsSuccessfulComponent",
        props: {
            seats: {
              type: Number,
              default: 1
            },
            showInviteButton: Boolean
        },
        mounted() {
            document.body.appendChild(this.$el);
            this.$refs['purchase-seats-successful'].show();
        },
        methods: {

            inviteMembers() {
                this.$root.$emit('hidePurchaseSeatsSuccessful');
                this.$root.$emit('showInviteMembers');
            },

            close() {
                this.$root.$emit('hidePurchaseSeatsSuccessful');
            }
        }
    }
</script>
